import { formatBytes } from "@/lib/utils";
import { UploadItem } from "./types";

export const isUploadComplete = (upload: UploadItem): boolean =>
    upload.status === 'completed' && !!upload.mediaInfo;
  
  export const isUploadActive = (upload: UploadItem): boolean =>
    upload.status === 'uploading';
  
  export const getUploadError = (upload: UploadItem): string | undefined =>
    upload.status === 'error' ? upload.error : undefined;
  
  // Note: zero renders as the plural "0 Bytes" here (the shared formatBytes
  // uses the singular "0 Byte"), so the zero case is handled locally.
  export const formatFileSize = (bytes: number): string =>
    bytes === 0
      ? '0 Bytes'
      : formatBytes(bytes, { decimals: 2, trimTrailingZeros: true });